import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ModalService } from "@core-services/modal.service";
import { KycModalFlowStep } from "@modules/kyc/domain/entities/kyc-modal-flow-step.model";
import { KYC_EDIT_DETAILS_DEEPLINK_VIEWED, KYC_REVIEW_POPUP_DEEPLINK_VIEWED } from "@helpers/constants";
import { KycModalComponent } from "@modules/kyc/components/kyc-modal/kyc-modal.component";
import { InitService } from "@core-services/init.service";
import { filter, take } from "rxjs/operators";
import { ServiceNames } from "@models/service_enums";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	selector: "kyc-route",
	template: "",
	standalone: false
})
export class KycRouteComponent {
	constructor(
		private router: Router,
		private modalService: ModalService,
		private readonly segmentService: SegmentService,
		private readonly rudderstackService: RudderstackService,
		private readonly initService: InitService
	) {
		this.initService
			.getInitiatedServicesAsObservable()
			.pipe(
				filter((services) => services.includes(ServiceNames.USER)),
				take(1)
			)
			.subscribe(() => {
				this.router
					.navigateByUrl("/home")
					.then(() =>
						this.modalService.create(KycModalComponent, { step: KycModalFlowStep.DATA_UPDATE }).present()
					);

				if (this.router.url === "/home/review-data") {
					this.segmentService.track({ name: KYC_REVIEW_POPUP_DEEPLINK_VIEWED });
					this.rudderstackService.track({ name: KYC_REVIEW_POPUP_DEEPLINK_VIEWED });
				}
				if (this.router.url === "/review-data") {
					this.segmentService.track({ name: KYC_REVIEW_POPUP_DEEPLINK_VIEWED });
					this.rudderstackService.track({ name: KYC_REVIEW_POPUP_DEEPLINK_VIEWED });
				}
				if (this.router.url === "/home/review-data/edit") {
					this.segmentService.track({ name: KYC_EDIT_DETAILS_DEEPLINK_VIEWED });
					this.rudderstackService.track({ name: KYC_EDIT_DETAILS_DEEPLINK_VIEWED });
				}
				if (this.router.url === "/review-data/edit") {
					this.segmentService.track({ name: KYC_EDIT_DETAILS_DEEPLINK_VIEWED });
					this.rudderstackService.track({ name: KYC_EDIT_DETAILS_DEEPLINK_VIEWED });
				}
			});
	}
}
